<template>
  <section class="modal-overlay" @click.self="close">
    <div class="modal-container">
      <div class="header-container">
        <button class="close-button mobile" @click="close" aria-label="Cerrar modal">
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
            <path d="M6 0.5L1 7.5L6 14.5" stroke="#464D5B" />
          </svg>
        </button>
        <h1 class="main-title">{{ recipe.title }}</h1>
        <button class="close-button desktop" @click="close" aria-label="Cerrar modal">
          <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
            <path d="M1 1L26 26M26 1L1 26" stroke="#464D5B" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>

      </div>
      <div class="separator-line"></div>
      <div class="content-container">
        <div class="image-container">
          <img v-if="recipe.webImg" :src="srcRecipeImg(recipe.id, recipe.webImg)" alt="">
          <img v-else src="@/assets/PlanAlimImg2.jpg" alt="">
          <!-- <span class="like-button" @click.stop="toggleLike">
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="38" height="38">
                <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61063 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70192 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70192 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7139 31.4286 12.8071C31.4286 11.2357 30.9048 9.92619 29.8572 8.87857C28.8095 7.83095 27.5 7.30714 25.9286 7.30714C24.6877 7.30714 23.5408 7.65914 22.4879 8.36314C21.4354 9.0674 20.6018 10.0471 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.0547 15.2185 8.35568C14.1709 7.65665 13.0266 7.30714 11.7857 7.30714C10.2243 7.30714 8.91722 7.83095 7.86462 8.87857C6.81203 9.92619 6.28573 11.2357 6.28573 12.8071C6.28573 13.7139 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                  fill="white" />
              </g>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none"
              :class="{ 'like-active': !liked }">
              <mask id="mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="38" height="38">
                <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask1)">
                <path
                  d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61062 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70193 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70193 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7138 31.4286 12.8071C31.4286 11.2357 30.9048 9.92617 29.8572 8.87855C28.8095 7.83093 27.5 7.30712 25.9286 7.30712C24.6877 7.30712 23.5408 7.65913 22.4879 8.36313C21.4354 9.06739 20.6018 10.047 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.05468 15.2185 8.35566C14.1709 7.65664 13.0266 7.30712 11.7857 7.30712C10.2243 7.30712 8.91722 7.83093 7.86462 8.87855C6.81203 9.92617 6.28573 11.2357 6.28573 12.8071C6.28573 13.7138 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.5429 16.3429 26.4846 18.8572 28.7571Z"
                  fill="white" />
                <path
                  d="M18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7138 31.4286 12.8071C31.4286 11.2357 30.9048 9.92617 29.8572 8.87855C28.8095 7.83093 27.5 7.30712 25.9286 7.30712C24.6877 7.30712 23.5408 7.65913 22.4879 8.36313C21.4354 9.06739 20.6018 10.047 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.05468 15.2185 8.35566C14.1709 7.65664 13.0266 7.30712 11.7857 7.30712C10.2243 7.30712 8.91722 7.83093 7.86462 8.87855C6.81203 9.92617 6.28573 11.2357 6.28573 12.8071C6.28573 13.7138 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                  fill="#FF3EA6" />
              </g>
            </svg>
          </span> -->
        </div>

        <div class="text-container">
          <div class="section-container">
            <div class="title-container">
              <h2 class="section-title desktop">Ingredientes</h2>
              <div class="mobile">
                <span class="section-title">Ingredientes</span>
              </div>
            </div>
            <div class="list-container">
              <ul class="text-list">

                <li v-for="ingredient in recipe.ingredients ">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                      <path
                        d="M5 0.333374C5.65089 0.333374 5.97633 0.798179 5.97633 1.72779C5.97633 2.14315 5.93688 2.62773 5.85799 3.18154L5.73965 3.95292C5.7002 4.28916 5.67061 4.49684 5.65089 4.57596L5.59172 4.96165L7.01183 3.83425C7.93886 3.08265 8.60947 2.70685 9.02367 2.70685C9.43787 2.70685 9.72387 2.86508 9.88166 3.18154C9.96055 3.30022 10 3.43867 10 3.5969C10 4.03204 9.77318 4.38806 9.31953 4.66496C8.8856 4.92209 8.29389 5.1891 7.54438 5.46601L6.21302 6.00004L7.86982 6.65275C8.46154 6.89009 8.89546 7.09777 9.1716 7.27578C9.72387 7.57247 10 7.94827 10 8.40318C10 8.54164 9.93097 8.72954 9.7929 8.96688C9.67456 9.18445 9.41815 9.29323 9.02367 9.29323C8.62919 9.29323 7.95858 8.91743 7.01183 8.16583L5.59172 7.03844L5.65089 7.48346C5.65089 7.58236 5.68047 7.78015 5.73965 8.07683L5.91716 9.11522C5.95661 9.5108 5.97633 9.90638 5.97633 10.302C5.97633 10.6778 5.88757 11.0041 5.71006 11.281C5.55227 11.5381 5.31558 11.6667 5 11.6667C4.68442 11.6667 4.43787 11.5381 4.26036 11.281C4.10256 11.0041 4.02367 10.6679 4.02367 10.2723C4.02367 9.85693 4.06312 9.37235 4.14201 8.81854L4.26036 8.04716C4.2998 7.71092 4.32939 7.50324 4.34911 7.42413L4.40828 7.03844L2.98817 8.16583C2.06114 8.91743 1.39053 9.29323 0.976331 9.29323C0.56213 9.29323 0.276134 9.135 0.118343 8.81854C0.0394477 8.69987 0 8.56141 0 8.40318C0 7.96805 0.216963 7.62191 0.650888 7.36479C1.10454 7.08788 1.70611 6.81098 2.45562 6.53407L3.78698 6.00004L2.13018 5.34734C1.55819 5.12977 1.1144 4.92209 0.798816 4.7243C0.266272 4.40784 0 4.03204 0 3.5969C0 3.45845 0.0591716 3.28044 0.177515 3.06287C0.315582 2.82552 0.532544 2.70685 0.828402 2.70685C1.14398 2.70685 1.45957 2.80574 1.77515 3.00353C2.09073 3.18154 2.49507 3.45845 2.98817 3.83425L4.40828 4.96165L4.34911 4.51662C4.34911 4.41772 4.31953 4.21994 4.26036 3.92325L4.08284 2.88486C4.04339 2.48928 4.02367 2.0937 4.02367 1.69812C4.02367 1.28276 4.10256 0.95641 4.26036 0.719064C4.43787 0.461937 4.68442 0.333374 5 0.333374Z"
                        fill="url(#paint0_linear_1499_3957)" />
                      <defs>
                        <linearGradient id="paint0_linear_1499_3957" x1="10" y1="6.00004" x2="0" y2="6.00004"
                          gradientUnits="userSpaceOnUse">
                          <stop stop-color="#FFE711" />
                          <stop offset="1" stop-color="#96FF11" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </span>
                  {{ ingredient }}
                </li>
              </ul>
            </div>
          </div>
          <div class="separator-line"></div>
          <!-- Procedimiento -->
          <div class="section-container">
            <div class="title-container">
              <h2 class="section-title desktop">Procedimiento</h2>
              <div class="mobile">
                <span class="section-title">Procedimiento</span>
              </div>
            </div>
            <div class="list-container">
              <ul class="text-list">
                <li>
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                      <path
                        d="M5 0.333374C5.65089 0.333374 5.97633 0.798179 5.97633 1.72779C5.97633 2.14315 5.93688 2.62773 5.85799 3.18154L5.73965 3.95292C5.7002 4.28916 5.67061 4.49684 5.65089 4.57596L5.59172 4.96165L7.01183 3.83425C7.93886 3.08265 8.60947 2.70685 9.02367 2.70685C9.43787 2.70685 9.72387 2.86508 9.88166 3.18154C9.96055 3.30022 10 3.43867 10 3.5969C10 4.03204 9.77318 4.38806 9.31953 4.66496C8.8856 4.92209 8.29389 5.1891 7.54438 5.46601L6.21302 6.00004L7.86982 6.65275C8.46154 6.89009 8.89546 7.09777 9.1716 7.27578C9.72387 7.57247 10 7.94827 10 8.40318C10 8.54164 9.93097 8.72954 9.7929 8.96688C9.67456 9.18445 9.41815 9.29323 9.02367 9.29323C8.62919 9.29323 7.95858 8.91743 7.01183 8.16583L5.59172 7.03844L5.65089 7.48346C5.65089 7.58236 5.68047 7.78015 5.73965 8.07683L5.91716 9.11522C5.95661 9.5108 5.97633 9.90638 5.97633 10.302C5.97633 10.6778 5.88757 11.0041 5.71006 11.281C5.55227 11.5381 5.31558 11.6667 5 11.6667C4.68442 11.6667 4.43787 11.5381 4.26036 11.281C4.10256 11.0041 4.02367 10.6679 4.02367 10.2723C4.02367 9.85693 4.06312 9.37235 4.14201 8.81854L4.26036 8.04716C4.2998 7.71092 4.32939 7.50324 4.34911 7.42413L4.40828 7.03844L2.98817 8.16583C2.06114 8.91743 1.39053 9.29323 0.976331 9.29323C0.56213 9.29323 0.276134 9.135 0.118343 8.81854C0.0394477 8.69987 0 8.56141 0 8.40318C0 7.96805 0.216963 7.62191 0.650888 7.36479C1.10454 7.08788 1.70611 6.81098 2.45562 6.53407L3.78698 6.00004L2.13018 5.34734C1.55819 5.12977 1.1144 4.92209 0.798816 4.7243C0.266272 4.40784 0 4.03204 0 3.5969C0 3.45845 0.0591716 3.28044 0.177515 3.06287C0.315582 2.82552 0.532544 2.70685 0.828402 2.70685C1.14398 2.70685 1.45957 2.80574 1.77515 3.00353C2.09073 3.18154 2.49507 3.45845 2.98817 3.83425L4.40828 4.96165L4.34911 4.51662C4.34911 4.41772 4.31953 4.21994 4.26036 3.92325L4.08284 2.88486C4.04339 2.48928 4.02367 2.0937 4.02367 1.69812C4.02367 1.28276 4.10256 0.95641 4.26036 0.719064C4.43787 0.461937 4.68442 0.333374 5 0.333374Z"
                        fill="url(#paint0_linear_1499_3957)" />
                      <defs>
                        <linearGradient id="paint0_linear_1499_3957" x1="10" y1="6.00004" x2="0" y2="6.00004"
                          gradientUnits="userSpaceOnUse">
                          <stop stop-color="#FFE711" />
                          <stop offset="1" stop-color="#96FF11" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </span>
                  <p v-html="recipe.instructions">

                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { url } from '../global/index';

export default {
  name: "BlankModal",
  props: {
    liked: {
      type: Boolean,
      default: false,
    },
    recipe: {
      type: Object,
      required: false,
    },
  },
  mounted() {
    document.body.classList.add("no-scroll");
  },
  beforeDestroy() {
    document.body.classList.remove("no-scroll");
  },
  methods: {
    close() {
      this.$emit("close");
    },
    toggleLike() {
      this.$emit("update:liked", !this.liked);
    },
    srcRecipeImg: function (idRec, img) {
      if (!img || img == "") {
        return "";
      }
      let src = `${url}/recipe-image/${idRec}/${img}`;

      return src;
    },
  },
};
</script>
<style>
.desktop {
  display: block;
}

.mobile {
  display: none;
}

.no-scroll {
  overflow: hidden;
}

.content-container::-webkit-scrollbar {
  -webkit-appearance: none;
}

.content-container::-webkit-scrollbar:vertical {
  width: 0.3645833333333333vw;
  background-color: #b8b8b8;
}

.content-container::-webkit-scrollbar-button:increment,
.content-container::-webkit-scrollbar-button {
  display: none;
}

.content-container::-webkit-scrollbar:horizontal {
  height: 0.3645833333333333vw;
}

.content-container::-webkit-scrollbar-thumb {
  background-color: #4400ffb7;
}

.content-container::-webkit-scrollbar-track {
  border-radius: 0.3645833333333333vw;
}
</style>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  display: flex;
  width: 56.9444vw;
  padding: 2.0833vw;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2.0833vw;
  border-radius: 2.0833vw;
  background: #fff;
  box-shadow: 0 0.2778vw 0.6944vw rgba(0, 0, 0, 0.1);
  max-height: 90vh;
}

.main-title {
  color: var(--Text, #464d5b);
  font-family: Manrope;
  font-size: 2.7778vw;
  font-weight: 500;
  line-height: normal;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: 1.875vw;
  height: 1.875vw;
}

.close-button svg {
  stroke: var(--Text, #464d5b);
  transition: stroke 0.2s;
}

.close-button:hover svg {
  stroke: #000;
}

.separator-line {
  width: 100%;
  height: 0.0694vw;
  min-height: 0.0694vw;
  background: #e3e3e9;
}

.image-container {
  display: flex;
  width: 24.0278vw;
  height: 38.8889vw;
  padding: 1.3889vw;
  align-items: flex-start;
  gap: 0.6944vw;
  flex-shrink: 0;
  position: sticky;
  top: 0;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 2.0833vw;

}

.like-button {
  position: absolute;
  top: 1.1111vw;
  left: 1.1111vw;
  z-index: 2;
  display: flex;
  width: 2.2222vw;
  height: 2.2222vw;
  cursor: pointer;
}

.like-button svg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.3s ease;
}

.like-active {
  opacity: 0;
}

.content-container {
  display: flex;
  gap: 2.0833vw;
  width: 100%;
  overflow-y: auto;
}

.text-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.6944vw;
}

.section-container {
  display: flex;
  flex-direction: row;
  gap: 1.3889vw;
  align-items: flex-start;
}

.title-container {
  flex: 0 0 10.4167vw;
}

.list-container {
  flex: 1;
}

.section-title {
  font-family: Manrope;
  font-size: 1.25vw;
  font-weight: 600;
  background: linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
}

.text-list {
  list-style: none;
  padding: 0;
  margin: 0;
  color: #464d5b;
  font-family: Manrope;
  font-size: 0.8333vw;
  line-height: 1.5;
}

.text-list li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.5em;
}

.icon {
  width: 1em;
  height: 1em;
  margin-right: 0.5em;
  flex-shrink: 0;
}

.icon svg {
  width: 100%;
  height: 100%;
}

@media (max-width: 530px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }

  .modal-container {
    width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }

  .header-container {
    position: relative;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .main-title {
    flex-grow: 1;
    text-align: center;
    font-size: 4.5vw;
  }

  .close-button {
    width: 3.25vw;
    height: 3.5vw;
  }

  .image-container {
    display: flex;
    width: 100%;
    height: 57.5vw;
    padding: 1.3889vw;
    gap: 0.6944vw;
    flex-shrink: 0;
    border-radius: 2.0833vw;
    position: relative;
  }

  .section-container {
    width: 100%;
    padding-top: 1.25vw;
    flex-direction: row;
    padding-right: 2.5vw;
  }

  .content-container {
    flex-direction: column;
    overflow-x: hidden;
  }

  .section-title {
    font-size: 3vw;
  }

  .list-container {
    flex: 0 0 70%;
  }

  .title-container {
    flex: 0 0 30%;
  }

  .text-list {
    font-size: 3vw;
  }

  .like-button {
    position: absolute;
    left: 83vw;
    z-index: 2;
    width: 11.75vw;
    height: 11.75vw;

  }

  .like-button svg {
    position: absolute;
    transition: opacity 0.3s ease;
  }

  .like-active {
    opacity: 0;
  }


}
</style>
